export default __webpack_public_path__ + "static/imgSSM6-178bb63a427f3b037cd8851a9fe20057.png";